{
  "auth.login.otp.phone.back.button_label": "Voltar",
  "auth.login.otp.phone.form.continue.button_label": "Continuar",
  "auth.login.otp.phone.form.country_code.label": "Código do país",
  "auth.login.otp.phone.form.country_code.invalid_error": "Selecione um código de país.",
  "auth.login.otp.phone.form.phone_number.helper_text": "Enviaremos um código por SMS para confirmar seu número.",
  "auth.login.otp.phone.form.phone_number.label": "Número de telefone",
  "auth.login.otp.phone.form.phone_number.placeholder": "Número de telefone",
  "auth.login.otp.phone.form.phone_number.invalid_error": "Não foi possível enviar o código para este número de telefone. Tente usar outro ou faça login com e-mail.",
  "auth.login.otp.phone.passcode.form.label": "Código",
  "auth.login.otp.phone.passcode.form.placeholder": "Código",
  "auth.login.otp.phone.passcode.form.resend.link_text": "Não recebeu o SMS? Reenviar código",
  "auth.login.otp.phone.passcode.form.resend.link_text.resending": "Reenviando...",
  "auth.login.otp.phone.passcode.form.switch_method.link_text": "Enviar código por e-mail em vez disso",
  "auth.login.otp.phone.passcode.helper_text": "Digite o código enviado para"
}
